import React, { useMemo } from 'react';

import StatusColorIndicator from '@adsk/alloy-react-status-color-indicator';

import { FORM_STATUSES, FEATURE_FLAGS } from './helpers/constants';
import { useTranslation } from './i18n';
import { usePlangridFeatureFlag } from './PlangridLaunchDarklyProvider';
import StatusColorLabel from './StatusColorLabel';

export const FIELD_REPORT_STATUS_COLORS = {
  [FORM_STATUSES.ARCHIVED]: StatusColorIndicator.COLORS.GRAY_LIGHT,
  [FORM_STATUSES.IN_REVIEW]: StatusColorIndicator.COLORS.YELLOW,
  [FORM_STATUSES.DRAFT]: StatusColorIndicator.COLORS.GRAY_DARK,
  [FORM_STATUSES.SUBMITTED]: StatusColorIndicator.COLORS.GREEN,
};

const FormStatus = ({ status, statusColorIndicatorHeight = 16 }) => {
  const { value: isStatusExpansionEnabled } = usePlangridFeatureFlag(
    FEATURE_FLAGS.STATUS_EXPANSION,
    false,
  );
  const { t } = useTranslation();

  const translationsMap = useMemo(
    () => ({
      archived: t('ARCHIVED'),
      draft: isStatusExpansionEnabled ? t('IN_PROGRESS') : t('DRAFT'),
      in_review: t('IN_REVIEW'),
      submitted: isStatusExpansionEnabled ? t('CLOSED') : t('SUBMITTED'),
    }),
    [t, isStatusExpansionEnabled],
  );

  return (
    <StatusColorLabel
      color={FIELD_REPORT_STATUS_COLORS[status]}
      label={translationsMap[status]}
      height={statusColorIndicatorHeight}
    />
  );
};

export default FormStatus;
